import { selectChangeMessageForDate } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForDate';
import type { EditAsideIssuedDatePicker } from '@nodeTypeConfig/configTypes';

export const publishComponent: EditAsideIssuedDatePicker = {
  component: 'issued',
  property: 'issued',
  label: 'Publicatiedatum',
  reactComponent: 'AsideIssuedDatePicker',
  options: {
    openTo: 'day',
  },
  asideChangeMessageSelector: selectChangeMessageForDate,
};
